/** Created by azhou on 2019/3/11.*/
<template>
    <div>
      <total-lists v-if="!isGroup || storeId"/>
      <group-money-lists v-else/>
    </div>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import TotalLists from './TotalLists'
  import GroupMoneyLists from './GroupMoneyLists'

  export default {
    name: 'StoreMoneyBus',
    components: { GroupMoneyLists, TotalLists},
    computed: {
      ...mapState(['currentStoreInfo']),
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store }
    },
    created () {
      if (this.isGroup) this.UPDATECURRENTSTORE({storeId:this.storeId});
    },
    destroyed() { 
      this.UPDATECURRENTSTORE({storeId:''});
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
    }
  }
</script>
